import React, {useEffect} from "react";
import {useQuery} from "react-query";
import {fetchContests, fetchPublicContests} from "../../api/api";
import {useAuth} from "../../common/AuthProvider";
import {ContestCard} from "./ContestCard";
import {LoadingSpinner} from "../contests/ContestPage";
import {Alert, Button, Card, Stack} from "react-bootstrap";
import {Page} from "../../common/Page";
import {AxiosError} from "axios";


export const HomePage = () => {
  const {isLoggedIn, setIsLoggedIn} = useAuth();

  const {data: contests, isLoading, error} = useQuery(["contests"],
    () => isLoggedIn ? fetchContests() : fetchPublicContests(),
    {
      retry: false // TODO: reconsider this
    })

  useEffect(() => {
    // This is possible if the user's browser preserves local storage but clears cookies since the last session.
    if (error && (error as AxiosError).response?.status === 401) {
      setIsLoggedIn(false)
    }
  }, [error, setIsLoggedIn]);

  return (
    <Page title={"Todd's prediction contests"}>
      <p>
        Hello and welcome 👋
      </p>

      <p>
        This is the home of Todd's annual prediction contest.
      </p>

      <p>
        Every December, we each estimate the chances of various events that <i>might</i> happen in the coming year.
      </p>

      <p>
        When the year ends, we check what actually happened—and see whose predictions were the most accurate.
      </p>

      <p>Please invite friends and family to join in.</p>

      {!isLoggedIn && !isLoading && (!contests || contests.contests.length === 0) && <p>
        <Card className={"mb-3"}>
          <Card.Body>
            <Card.Title>
              No contests available
            </Card.Title>
            <Card.Text>Create an account so you're notified about upcoming contests!</Card.Text>
            <Stack direction={"horizontal"} gap={2}>
              <Button href={"/create-account"} variant={"primary"}>Create account</Button>
              <Button href={"/login"} variant={"outline-secondary"}>Log in</Button>
            </Stack>
          </Card.Body>
        </Card>
      </p>}

      {isLoading && <LoadingSpinner/>}
      {contests && contests.contests.map(contest =>
        <ContestCard key={contest.id} contest={contest}/>)}
      {!!error && <Alert variant={"danger"}>Failed to load contests.</Alert>}

    </Page>
  );
}